import { Components, Theme } from "@mui/material";

export const MuiTable: Components<Omit<Theme, "MuiTable">>["MuiTable"] = {
  defaultProps: {
    size: "medium",
  },
};
